module.exports = __webpack_public_path__ + "img/1968.98fb6874.png";